export default "__VITE_ASSET__BDaJxgIC__"